<template>
    <ui-modal>
        <template #header>
            <h3 v-text="'Rejestracja umowy z Operatorem'" class="mb-1 text-center" />
        </template>

        <div v-if="!isLoading && operators" class="py-3">
            <h4 v-text="'Wybierz Operatora:'" />
            <check-list
                class="operators-list pt-2"
                type="radio"
                :list="operators"
                :select-row="onSelectOperator"
                :selected-rows="[selectedOperator]"
                :disabled-rows="disabledOperators"
            />
        </div>
        <div v-else>
            <page-preloader min-height="10rem" loading-status="loading" />
        </div>

        <template #footer>
            <the-btn
                class="btn-outline-custom"
                text="Zamknij"
                @click="$emit('close-modal')"
            />
            <the-btn
                class="btn-secondary"
                text="Przejdź dalej"
                :disabled="!selectedOperator"
                @click="goToContract"
            />
        </template>
    </ui-modal>
</template>

<script>
import DrsOperatorsStore from '@/store/modules/drs/drs-operators.module'
import { registerPageModule } from '@/utils/store'
import { mapGetters, mapActions } from 'vuex'

export default {
    data() {
        return{
            selectedOperator: null,
            disabledOperators: []
        }
    },
    beforeCreate() {
        registerPageModule(this.$store, DrsOperatorsStore, 'drsOperators')
    },
    created() {
        this.fetchOperators()
        this.loadAndInitDisabledOperators()
    },
    computed: {
        ...mapGetters('drs', {
            locations: 'shopsWithActiveService'
        }),
        ...mapGetters('drsOperators', ['getOperators', 'getStatus', 'getOperatorSubs', 'getOperatorSubsStatus']),
        operators() {
            return this.getOperators.map(({ id, name: label, code, graphics }) => ({
                id,
                label,
                code,
                img: graphics?.smallIconMinioUrl,
                imgHeight: 40,
                tooltip: this.disabledOperators.includes(id)
                    ? 'Umowa we wszystkich sklepach została już zarejestrowana'
                    : null
            }))
        },
        isLoading() {
            return this.getStatus === 'loading' || this.getOperatorSubsStatus === 'loading'
        }
    },
    methods: {
        ...mapActions('drsOperators', ['fetchOperators', 'fetchAndMapOperatorSubscriptions']),
        async loadAndInitDisabledOperators() {
            if (!this.$store.getters.modalState.args?.skipFetchSubs) {
                // fetch operator subscriptions
                await this.fetchAndMapOperatorSubscriptions({
                    params: {
                        locationIds: this.locations.map(({ id }) => id).join(',')
                    }
                })
            }
            // set disabledOperators
            this.disabledOperators = this.getOperators
                .filter(op => {
                    const subs = this.getOperatorSubs.find(({ id }) => id === op.id)?.subscriptions || []
                    if (!subs.length) return false

                    const locIds = this.locations.map(({ id }) => id)
                    return locIds.every(id => subs.includes(id))
                })
                .map(({ id }) => id)
        },
        async goToContract() {
            if (!this.selectedOperator.value) return

            this.$store.dispatch('toggleModal', false)

            // open OperatorContract Modal
            const { id, label: name, code } = this.operators.find(({ id }) => id === this.selectedOperator.id)
            this.$nextTick(() => {
                this.$store.dispatch('openModal', {
                    componentPath: 'drs/operators/OperatorContract',
                    args: {
                        selectedOperator: { id, name, code }
                    }
                })
            })
        },
        onSelectOperator(operator) {
            this.selectedOperator = operator?.value ? operator : null
        }
    }
}
</script>

<style lang="scss">
@import '../../../styles/_custom.scss';
@import '~bootstrap/scss/mixins';

.operators-list .m-checkList {
    &__row {
        flex-wrap: nowrap;
    }
    @include media-breakpoint-up(md) {
            &__rows {
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                gap: 1rem;
            }
        &__row + .m-checkList__row {
            margin: 0;
        }
    }
}
</style>